<!--
Copyright 2020 The Ground Authors.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->

<button mat-button color="primary" aria-label="back" (click)="onCloseClick()">
  <mat-icon>arrow_back</mat-icon>
  <span>Back</span>
</button>
<mat-list-item>
  <img
    *ngIf="loiGeometryType === geometryType.POINT"
    matListItemAvatar
    [src]="pinUrl"
    alt="point"
  />
  <img
    *ngIf="loiGeometryType === geometryType.POLYGON"
    matListItemAvatar
    src="/assets/img/polygon_icon.svg"
    alt="polygon"
  />
  <h3 matLine>{{ loiDisplayName }}</h3>
  <div matLine>
    <div class="job-name">{{ job?.name }}</div>
  </div>
  <button mat-icon-button [matMenuTriggerFor]="loiMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #loiMenu="matMenu">
    <button
      mat-menu-item
      aria-label="delete"
      (click)="onDeleteLocationOfInterestClick()"
    >
      <mat-icon>delete_forever</mat-icon>
      <span>Delete loi</span>
    </button>
  </mat-menu>
</mat-list-item>
